(function ($) {
    'use strict';

    var prfx = 'acom';

    acom_app.views.Header = Backbone.View.extend({
        el: 'body',
        wrapper: '#acom-header',
        template: _.template($("#" + prfx + "-header-template").html()),
        bindEvents: function () {
            $(document).on('click.acom', '.cd-nav-trigger', ACOM.toggleNavigation)
            $(document).on('click.acom', '.cd-search-trigger', this.openSearchForm)
        },
        initialize: function () {

        },
        render: function () {
            this.close();

            var social = window.acom_app.models.settings.get('accounts.social')
            var result = {
                social: social,
                site_title: window.acom_app.models.helper.get('site_title')
            }

            result = _.extend({}, result, window.acom_app.models.settings.toJSON());

            var html = this.template(result);
            this.$el.prepend(html);
            this.bindEvents();
            this.afterRender();

            return this;
        },
        openSearchForm: function (e) {
            e.preventDefault();
            ACOM.openSearchForm();
        },
        rendered: function () {
            return $.contains(document, $(this.wrapper).get(0));
        },
        afterRender: function () {
            var nav = new acom_app.views.Nav();
            nav.render();
        },
        close: function () {
            $(this.wrapper).remove();

            $(document).off('click.acom', '.cd-nav-trigger')
            $(document).off('click.acom', '.cd-search-trigger')
        }
    })
})(jQuery)